import { render } from "./who_to_follow.vue?vue&type=template&id=4f8c3288"
import script from "./who_to_follow.js?vue&type=script&lang=js&external"
export * from "./who_to_follow.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__